import { all } from 'redux-saga/effects'

import distraintsSaga from './Gnosus/scenes/Distraints/saga'
import entitySearchSaga from './Gnosus/components/EntityStack/components/StackContent/components/SearchContent/saga'
import exportBackgroundTasksSaga from './Gnosus/components/EntityStack/components/StackContent/components/ExportsContent/saga'
import fanalSaga from '../components/FinanceAnalysis/saga'
import favouritesSaga from './Gnosus/components/EntityStack/components/StackContent/components/FavouritesContent/saga'
import fstmtSaga from '../components/FinanceResults/saga'
import groupMembersImportSaga from '../components/Dialog/components/GroupMembersImport/saga'
import groupMonitoringSaga from '../components/Dialog/components/GroupMonitoring/saga'
import groupSaga from '../components/GroupEntity/saga'
import groupsContentSaga from './Gnosus/components/EntityStack/components/StackContent/components/GroupsContent/saga'
import groupStackSaga from './Gnosus/components/GroupStack/saga'
import historySaga from './Gnosus/components/EntityStack/components/StackContent/components/HistoryContent/saga'
import linkagesSaga from './Gnosus/scenes/Linkages/saga'
import manageGroupsSaga from '../components/Dialog/components/ManageGroups/saga'
import minireportSaga from '../components/Minireport/saga'
import portfolioSaga from './Gnosus/scenes/Portfolio/saga'
import reportSaga from './Gnosus/scenes/Report/saga'
import tabsSaga from './Gnosus/components/Tabs/saga'
import toolbarSaga from './Gnosus/components/Toolbar/saga'
import userProfileSagas from '../components/Dialog/components/UserProfile/components/Content/sagas'
import workspaceBlockSaga from './Gnosus/components/Workspace/components/HocBlock/saga'

export default function* () {
    yield all([
        distraintsSaga(),
        entitySearchSaga(),
        exportBackgroundTasksSaga(),
        fanalSaga(), // FinanceAnalysis used in Finance and Report component saga
        favouritesSaga(),
        fstmtSaga(), // FinanceResults used in Finance and Report component saga
        groupMembersImportSaga(),
        groupMonitoringSaga(),
        groupSaga(),
        groupsContentSaga(),
        groupStackSaga(),
        historySaga(),
        linkagesSaga(),
        manageGroupsSaga(),
        minireportSaga(),
        portfolioSaga(),
        reportSaga(),
        tabsSaga(),
        toolbarSaga(),
        userProfileSagas(),
        workspaceBlockSaga(),
    ])
}
